<section class="form-with-guidance-wrapper">
  <section class="form-alert-wrapper">
      <rappider-crud-view-edit-form [config]="editFormConfig"
                                    [submitButtonLoading]="submitButtonLoading"
                                    (formSubmit)="onFormSubmit($event)"></rappider-crud-view-edit-form>
      <rappider-alert [ngStyle]="{ display: errorAlertConfig?.description?.text ? 'block' : 'none' }"
                      [type]="errorAlertConfig.type"
                      [title]="errorAlertConfig.title"
                      [description]="errorAlertConfig.description"
                      [showIcon]="errorAlertConfig.showIcon"
                      [closeable]="errorAlertConfig.closeable"></rappider-alert>
  </section>
  <section class="markdown-viewer-wrapper">
      <rappider-markdown-viewer [markdownText]="content"></rappider-markdown-viewer>
  </section>
</section>
